import React, { useEffect, useState } from "react";
import GroupOrder from "../../assets/GroupOrder.png";
import calender from "../../assets/calender.png";
import profile from "../../assets/profile.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import statusIcon from "../../assets/orders/status.png";
import check from "../../assets/orders/check.png";
import stepsCompleted from "../../assets/orders/stepsCompleted.png";
import { Link } from "react-router-dom";
import {
  ArrowDownOutlined,
  CheckCircleFilled,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Carousel, Collapse, Input, message, Modal, Rate } from "antd";
import { fetchOrderById } from "../../redux/ShowOrderIdSlice";
import { useDispatch, useSelector } from "react-redux";
import { submitFeedback } from "../../redux/rateOrderSlice";
import prev from "../../assets/previewRequests/prev.png";
import build from "../../assets/previewRequests/build.png";
import size from "../../assets/previewRequests/size.png";
import door from "../../assets/previewRequests/door.png";
import floors from "../../assets/previewRequests/floors.png";
import { useTranslation } from "react-i18next";
import ReactStars from "react-stars";
import { submitRatePreview } from "../../redux/ratePreviewSlice";

const { TextArea } = Input;

const Completed = ({
  id,
  date,
  time,
  statuss,
  description,
  addresss,
  area,
  levels_count,
  units_count,
  images,
  construction_type,
  rates,
  rates_comment,
  attach_file,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [collapsed, setCollapsed] = useState(false);
  let [open, setOpen] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    {
      collapsed ? <DownOutlined /> : <UpOutlined />;
    }
  };
  const customExpandIcon = ({ isActive }) =>
    isActive ? (
      <UpOutlined className="plus-icon mt-4" />
    ) : (
      <DownOutlined className="plus-icon mt-4" />
    );

  const dispatch = useDispatch();

  const feedbackStatus = useSelector((state) => state.status);

  const [rate, setRate] = useState(0);
  const handleRatingChange = (newRating) => {
    setRate(newRating);
  };
  const [rateComment, setRateComment] = useState("");

  const [isModalView, setIsModalView] = useState(false);

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const items = [
    {
      key: "1",
      label: (
        <>
          <h3 className="text-[#525D71] font-semibold">{t("Order Details")}</h3>
        </>
      ),
      children: (
        <div>
          <div className="px-5">
            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img src={calender} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">
                  {date} | {time}
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img src={address} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">{addresss}</p>
              </div>
            </div>

            <div className="flex items-start mt-5 ">
              <img src={desc} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
              <p className="text-[#283D63] font-medium">{description}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img src={upload} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                {images?.uploaded_images?.length > 0 ? (
                  <>
                    <button
                      onClick={showModalView}
                      className="text-[#6682B6] underline font-medium"
                    >
                      {t("View Uploaded Images")}
                    </button>
                    <Modal
                      title={t("Uploaded Images")}
                      className="orderModal orderModalPricing w_small_modal"
                      open={isModalView}
                      onOk={handleOkView}
                      onCancel={handleCancelView}
                      footer={null}
                    >
                      <Carousel
                        arrows
                        infinite={false}
                        className="custome_carousel_images"
                      >
                        {images?.uploaded_images?.map((img, index) => (
                          <div key={index}>
                            <img
                              src={`https://service.samoolah.com/${img}`}
                              alt={`Uploaded image ${index + 1}`}
                              className="w-[120px] mx-auto my-5"
                            />
                          </div>
                        ))}
                      </Carousel>
                    </Modal>
                  </>
                ) : (
                  <p className="text-[#283D63] font-medium">
                    {t("No Uploaded Images")}
                  </p>
                )}
              </div>
              <div className="flex items-center mt-3 ">
                <img src={statusIcon} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">{t("Status")}</p>
                <p className="text-[#283D63] font-medium ml-2">{statuss}</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img src={build} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">
                {t("Property:")}
                  <span className={`text-[#283D63] ${
                      language == "en" ? "ml-1" : "mr-1"
                    }`}>
                    {construction_type}
                  </span>
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img src={size} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">
                {t("Area in square meters:")}
                </p>
                <p className={`text-[#283D63] font-medium ${
                    language == "en" ? "ml-2" : "mr-2"
                  }`}>{area}</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img src={floors} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">
                {t("Number of floors:")}
                  <span className={`text-[#283D63] ${
                      language == "en" ? "ml-1" : "mr-1"
                    }`}>{levels_count}</span>
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img src={door} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">
                {t("Number of apartments:")}
                </p>
                <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>{units_count}</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];
  const onChange = (key) => {
    console.log(key);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = async () => {
    if (!rate) {
      message.error(t("Please provide a rating."));
      return;
    }

    const feedbackData = {
      construction_preview_id: id,
      rate,
      rate_comment: rateComment,
    };

    try {
      await dispatch(submitRatePreview(feedbackData))
        .unwrap()
        .then(() => {
          setIsModalOpen(false);
          message.success(t("Thank you for your feedback!"));
        });
    } catch (error) {
      console.error(t("Error submitting feedback:"), error);
      message.error(t("Failed to submit feedback. Please try again."));
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div>

      <div className="mx-auto text-center">
        <img src={check} className="w-[50px] mx-auto my-5" />
        <p className="text-[#525D71] font-semibold">{t("Order Complete")}</p>
      </div>
      <div className="my-5 mx-auto">
        <img
          src={prev}
          className="w-[120px] mx-auto bg-[#FCFBFA] rounded-2xl p-3"
        />
      </div>

      <div className="text-center">
        <p className="text-[#737E91] font-semibold text-xl">
        {t("Order number")}
          <span className="text-[#283D63] font-semibold">#{id}</span>
        </p>
        <p className="text-[#A6ADB9] mt-2">
        {t("Order created on")} {date} <br /> {time}
        </p>
      </div>

      <button className="text-[#FE9B71] rounded-full text-lg font-semibold border-2 border-[#FE9B71] px-10 py-2 mt-5 mb-5 flex mx-auto">
      {t("View receipt")}
      </button>

      <Collapse
        defaultActiveKey={["1"]}
        inlineCollapsed={collapsed}
        items={items}
        expandIcon={customExpandIcon}
        expandIconPosition="right"
        bordered={false}
        className="bg-white custom_collapse"
      />

      {/* <div className="mt-3">
        <div className="flex items-center">
          <p className="bg-[#FCFBFA] text-[#525D71] py-4 px-5 text-xl rounded-xl w-full font-semibold">
            Final report.pdf
          </p>
          <a href={`https://service.samoolah.com${attach_file}`} download="Final report.pdf" className="bg-[#ff773e] text-white rounded-full py-4 px-5 mx-5">
            <ArrowDownOutlined className="text-xl"/>
          </a>
        </div>
      </div> */}

      <div className="mt-3">
        <div className="flex items-center">
          <p className="bg-[#FCFBFA] text-[#525D71] py-4 px-5 text-xl rounded-xl w-full font-semibold">
            Final report.pdf
          </p>
          <a
            href={`https://service.samoolah.com${attach_file}`}
            download="Final report.pdf"
            className="bg-[#ff773e] text-white rounded-full py-4 px-5 mx-5"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ArrowDownOutlined className="text-xl" />
          </a>
        </div>
      </div>

      <div className="mt-3">
        {rates === 0 ? (
          <>
            <h3 className="text-[#14294F] text-xl font-semibold">
               {t("Rate Company")}
            </h3>
            <p className="text-[#42567B] mt-4 text-center font-semibold">
            {t("How satisfied are you with the service provided?")}
            </p>
            <>
              <ReactStars
                count={5}
                onChange={handleRatingChange}
                value={rate}
                size={30}
                color1={"#dcdcdc"}
                color2={"#ffd700"}
                half={true}
                className="mx-auto flex justify-center mt-0 relative z-10"
              />

              <p className="text-[#42567B] mt-1 text-center">
              {t("Do you have any reviews or suggestions that you’d like to share?")}
              </p>

              <div className="lg:mx-10">
                <TextArea
                  placeholder={t("Type in here your reviewsuggestions")}
                  allowClear
                  onChange={(e) => setRateComment(e.target.value)}
                  className="w-full my-4 border-0 h-[100px] rounded-3xl"
                />
              </div>

              <div>
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={feedbackStatus === "loading"}
                  className={`bg-[#FE9B71] text-white rounded-full px-14 py-3 text-lg mx-auto flex ${
                    feedbackStatus === "loading" &&
                    "opacity-50 cursor-not-allowed"
                  }`}
                >
                  {feedbackStatus === "loading" ? t("Submitting...") : t("Submit")}
                </button>
                <Modal
                  title=""
                  className="orderModal orderModalPricing w_small_modal"
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  footer={null}
                >
                  <div className="mt-6">
                    <p className="text-[#14294F] text-center font-bold text-xl">
                    {t("Your feed back has been submitted")} <br /> {t("Successfully")}
                    </p>
                    <p className="text-[#A6ADB9] text-center text-lg my-4">
                    {t("Thanks for giving the time to rate our services.")}
                    </p>
                    <button
                      onClick={handleCancel}
                      className="bg-[#FE9B71] text-white rounded-full px-10 py-2 text-lg mx-auto flex my-4 mt-8"
                    >
                      {t("Continue")}
                    </button>
                  </div>
                </Modal>
              </div>
            </>
          </>
        ) : (
          <>
            <h3 className="text-[#14294F] text-xl font-semibold">{t("My Rate")}</h3>
            <p className="text-[#42567B] mt-4 text-center font-semibold">
            {t("You gave a total of")}
            </p>
            <div className="mx-auto flex justify-center mt-4">
              <Rate disabled defaultValue={rates} />
            </div>
            <p className="text-[#42567B] mt-4 text-center font-semibold">
               {t("Your review")}
            </p>
            <p className="bg-[#F9FBFC] text-[#A3B9DD] p-4 rounded-xl mt-4">
              {rates_comment}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Completed;
